/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

export default function AddUserClientDialog({
  title,
  description,
  clients,
  user,
  userID,
  primaryButtonText,
  secondaryButtonText,
  open,
  onClose,
  onSecondaryButtonClick,
  onPrimaryButtonClick,
  setAddDialogOpen,
}) {
  const [clientIds, setClientIds] = useState(user.clients.map(c => c.id));
  const handleChangeMultiple = (event, value) => {
    if (value) {
      setClientIds(value.map(val => val.id));
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
        <Autocomplete
          multiple
          labelid="select-label"
          id="simple-select"
          options={clients.filter(c => !clientIds.includes(c.id))}
          disableCloseOnSelect
          defaultValue={user.clients}
          onChange={handleChangeMultiple}
          getOptionLabel={option => option.name}
          renderOption={option => <Typography variant="subtitle">{option.name}</Typography>}
          renderInput={params => <TextField {...params} variant="outlined" label="Clients" />}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onSecondaryButtonClick}>{secondaryButtonText}</Button>
        <Button
          variant="contained"
          onClick={() => {
            onPrimaryButtonClick(userID, clientIds);
            setAddDialogOpen(false);
          }}
          color="secondary"
          autoFocus
        >
          {primaryButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AddUserClientDialog.defaultProps = {
  title: '',
  description: '',
  clients: [],
  primaryButtonText: '',
  secondaryButtonText: '',
  userID: '',
  open: false,
  onClose: () => {},
  onSecondaryButtonClick: () => {},
  onPrimaryButtonClick: () => {},
  setAddDialogOpen: () => {},
};

AddUserClientDialog.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      billingAddressLine1: PropTypes.string,
      billingAddressLine2: PropTypes.string,
      billingAddressZip: PropTypes.string,
      billingAddressState: PropTypes.string,
      billingAddressCity: PropTypes.string,
    })
  ),
  userID: PropTypes.number,
  user: PropTypes.shape({
    id: PropTypes.number,
    email: PropTypes.string,
    created: PropTypes.string,
    roles: PropTypes.shape({
      app: PropTypes.arrayOf(PropTypes.string),
    }),
    clients: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        billingAddressLine1: PropTypes.string,
        billingAddressLine2: PropTypes.string,
        billingAddressZip: PropTypes.string,
        billingAddressState: PropTypes.string,
        billingAddressCity: PropTypes.string,
      })
    ),
  }).isRequired,
  primaryButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSecondaryButtonClick: PropTypes.func,
  onPrimaryButtonClick: PropTypes.func,
  setAddDialogOpen: PropTypes.func,
};
